/* eslint-disable class-methods-use-this */
/* eslint-disable import/prefer-default-export */
import IBase from './base';

// 页面埋点
class IPV extends IBase {
  // 换电_门店列表
  shopList() {
    this.pv({
      ios: 'IOS_换电_门店列表',
      android: 'Android_换电_门店列表',
      alipay: 'Alipay_换电_门店列表页',
    });
  }

  // 换电_个人中心
  userCenter() {
    this.pv('switchpower_mycenter');
  }

  // 换电_购买记录
  userPackage() {
    this.pv('switchpower_payment_history');
  }

  // 换电_购买记录_订单详情页
  userPackageOrderDetail(orderId) {
    this.pv('switchpower_orderdetails', { orderId });
  }

  // 换电_购买记录_退款申请
  userPackageRefund(orderId) {
    this.pv('switchpower_refundpage', { orderId });
  }

  // 换电_我的资料
  userInfo() {
    this.pv('switchpower_myinformation');
  }

  // 换电_购买套餐
  buyPackage() {
    this.pv('switchpower_goodslist');
  }

  // 换电_换电记录
  record() {
    this.pv('switchpower_switch_history');
  }

  // 换电_我的电池
  myBattery() {
    this.pv('switchpower_mybattery');
  }

  // 换电_支付明细
  payInfo() {
    this.pv({
      ios: 'IOS_换电_支付明细',
      android: 'Android_换电_支付明细',
      alipay: 'Alipay_换电_支付明细',
    });
  }

  // 换电_我的保险
  myInsurance() {
    this.pv('switchpower_myinsurance');
  }

  // 换电_车辆绑定
  bikeBind() {
    this.pv({
      ios: 'IOS_换电_车辆绑定',
      android: 'Android_换电_车辆绑定',
      alipay: 'Alipay_换电_车辆绑定',
    });
  }

  // 换电_车辆详情
  bikeInfo() {
    this.pv({
      ios: 'IOS_换电_车辆详情',
      android: 'Android_换电_车辆详情',
      alipay: 'Alipay_换电_车辆详情',
    });
  }

  // 换电_重新绑定车辆
  bikeReBind() {
    this.pv({
      ios: 'IOS_换电_重新绑定车辆',
      android: 'Android_换电_重新绑定车辆',
      alipay: 'Alipay_换电_重新绑定车辆',
    });
  }

  // 换电_我的优惠券
  userCoupon() {
    this.pv('switchpower_mycoupon');
  }

  // 换电_我的押金详情
  depositInfo() {
    this.pv('switchpower_mydeposit');
  }

  // 换电_押金支付页
  depositPay() {
    this.pv('switchpower_deposit_payment');
  }

  // 新版我的押金页
  myDeposit(packagesStatus) {
    this.pv('switchpower_mydeposit', { packagesStatus });
  }

  // 换电_开仓页
  unlock() {
    this.pv('switchpower_opencabinet');
  }

  // 换电_手动输码页
  manualInput() {
    this.pv('switchpower_entercode');
  }

  // 换电_预热引导页
  // preHot() {
  //   // TODO 不在此项目
  //   this.pv({
  //     ios: 'IOS_换电_预热引导页',
  //     android: 'Android_换电_预热引导页',
  //     alipay: 'Alipay_换电_预热引导页',
  //   });
  // }

  // 换电_卡券兑换
  exchange() {
    this.pv({
      ios: 'IOS_换电_卡券兑换',
      android: 'Android_换电_卡券兑换',
      alipay: 'Alipay_换电_卡券兑换',
    });
  }

  // 邀请明细
  invitingDetail() {
    this.pv('switchpower_inviting_detail');
  }

  // ------ 卡卷-----//

  // 车服H5活动页
  stationActivateH5(source = '') {
    this.pv('station_H5', { source });
  }

  // 车服开卡权益页
  stationActivateRights(source = '') {
    this.pv('station_activate_rights', { source });
  }
  // ------ 卡卷 end-----//
}

export const PV = new IPV();
